/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./confirmModal.vue?vue&type=template&id=bba0b942&scoped=true&"
import script from "./confirmModal.vue?vue&type=script&lang=js&"
export * from "./confirmModal.vue?vue&type=script&lang=js&"
import style0 from "./confirmModal.vue?vue&type=style&index=0&id=bba0b942&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_webpack@5.89.0__lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba0b942",
  null
  
)

export default component.exports